const LANGUAGES = {
	PL: {
		name: 'Polski',
		flag: 'pl',
	},
	EN: {
		name: 'English',
		flag: 'gb',
	},
	DE: {
		name: 'Deutsch',
		flag: 'de',
	},
	SK: {
		name: 'Slovensky',
		flag: 'sk',
	},
	CZ: {
		name: 'Česky',
		flag: 'cz',
	},
} as const;

export default LANGUAGES;
